import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from 'vue2-toast'
import '../../plugins/axios'

import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'vue2-toast/lib/toast.css'
import 'swiper/dist/css/swiper.css'
import './assets/styles/style.styl'

import 'lightgallery.js/dist/css/lightgallery.css'
import 'lightgallery.js'

import '../../plugins/filter'

// import AdminApp from './AdminApp'
// import adminRouter from './router/app'

import components from './components'

Object.keys(components).forEach(key => {
  Vue.component(key, components[key])
})


Vue.use(Toast, {
  type: 'center',
  duration: 1000,
  wordWrap: false,
  width: 'auto'
});

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
